import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import { useEffect, useState } from 'react';
import { LAYOUT_CONTAINER_ID } from '../../../../constants';
import { useLayoutOptions } from '../../../layout-options-provider';
import useContainerHasScroll from '../../hooks/use-container-has-scroll';
import type { NavigationHeaderBGVariant } from '../../types';
type NavigationHeaderContainerProps = {
  top?: number;
  containerId: string;
};
const NavigationHeaderContainer = t0 => {
  const $ = _c(25);
  const {
    top,
    containerId
  } = t0;
  const hasScroll = useContainerHasScroll(containerId);
  const {
    header: t1,
    navigationPortalId
  } = useLayoutOptions();
  const {
    options
  } = t1;
  const {
    position: headerPosition,
    background: headerBackground
  } = options;
  const [headerTop, setHeaderTop] = useState(0);
  const [layoutContainerWidth, setLayoutContainerWidth] = useState(0);
  let t2;
  let t3;
  if ($[0] !== headerPosition || $[1] !== top) {
    t2 = () => {
      const layoutContainer = document.querySelector(`#${LAYOUT_CONTAINER_ID}`);
      const updateDimensions = () => {
        const containerTop = layoutContainer?.getBoundingClientRect().top || 0;
        const containerWidth = layoutContainer?.clientWidth || 0;
        setLayoutContainerWidth(containerWidth);
        let newHeaderTop = top ?? 0;
        if (headerPosition === "floating" || headerPosition === "button-only") {
          newHeaderTop = newHeaderTop + containerTop;
        }
        setHeaderTop(newHeaderTop);
      };
      const resizeObserver = new ResizeObserver(updateDimensions);
      if (layoutContainer) {
        resizeObserver.observe(layoutContainer);
      }
      return () => {
        if (layoutContainer) {
          resizeObserver.unobserve(layoutContainer);
        }
      };
    };
    t3 = [headerPosition, top];
    $[0] = headerPosition;
    $[1] = top;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  const isFloatingOrButtonOnly = headerPosition === "floating" || headerPosition === "button-only";
  const isSticky = headerPosition !== "nonSticky";
  const buttonOnly = headerPosition === "button-only";
  const isFixed = isFloatingOrButtonOnly;
  const isRelative = headerPosition === "nonSticky";
  const showBorder = hasScroll && !buttonOnly && !isRelative;
  let t4;
  if ($[4] !== buttonOnly || $[5] !== isFixed || $[6] !== layoutContainerWidth) {
    t4 = isFixed && !buttonOnly ? {
      width: `${layoutContainerWidth}px`
    } : {};
    $[4] = buttonOnly;
    $[5] = isFixed;
    $[6] = layoutContainerWidth;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== headerTop || $[9] !== isFixed) {
    t5 = isFixed ? {
      top: `${headerTop}px`
    } : {};
    $[8] = headerTop;
    $[9] = isFixed;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = {
      ...t4,
      ...t5
    };
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const dynamicStyles = t6;
  let t7;
  if ($[14] !== buttonOnly || $[15] !== headerBackground || $[16] !== isFixed || $[17] !== isRelative || $[18] !== isSticky || $[19] !== showBorder) {
    t7 = cx("px-4 md:px-3", getBackgroundClasses(headerBackground, buttonOnly), isFixed && "fixed", isRelative && "relative", isSticky ? "z-sticky" : "z-0", showBorder && "has-[[data-has-content]]:border-b border-solid border-tertiary");
    $[14] = buttonOnly;
    $[15] = headerBackground;
    $[16] = isFixed;
    $[17] = isRelative;
    $[18] = isSticky;
    $[19] = showBorder;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== dynamicStyles || $[22] !== navigationPortalId || $[23] !== t7) {
    t8 = <header id={navigationPortalId} className={t7} style={dynamicStyles} />;
    $[21] = dynamicStyles;
    $[22] = navigationPortalId;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  return t8;
};
const getBackgroundClasses = (background: NavigationHeaderBGVariant, buttonOnly: boolean): string => {
  if (buttonOnly) {
    return 'bg-transparent';
  }
  if (background === 'transparent') {
    return 'bg-transparent';
  }
  if (background === 'dark-glass') {
    return 'bg-black/20 backdrop-blur-[12px] [-webkit-backdrop-filter:blur(12px)]';
  }
  if (background === 'light-glass') {
    return 'bg-primary/20 backdrop-blur-[10px] [-webkit-backdrop-filter:blur(10px)]';
  }
  return '';
};
export default NavigationHeaderContainer;